(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i];
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0];
    if(linkEl.getAttribute('data-size')){
      size = linkEl.getAttribute('data-size').split('x');
    }else{
      size = [];
    }
    
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };

    if (figureEl.children.length > 1) {
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl;
    items.push(item);
  }

  return items;
};

var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }

  if (index >= 0) {
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  options = {
    maxSpreadZoom: 1,
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),
  };

  if (fromURL) {
    if (options.galleryPIDs) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

initPhotoSwipeFromDOM('.my-gallery');




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  class CustomProductGrid {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.wrapper = document.querySelector(`.cpg-wrapper-${sectionId}`);
      if (!this.wrapper) return;

      this.grid = this.wrapper.querySelector('.cpg-grid');
      this.items = this.wrapper.querySelectorAll('.cpg-product-card');
      this.prevBtn = this.wrapper.querySelector('.cpg-header-nav-prev');
      this.nextBtn = this.wrapper.querySelector('.cpg-header-nav-next');
      this.dotsContainer = this.wrapper.querySelector('.cpg-dots');
      
      this.currentIndex = 0;
      this.totalItems = this.items.length;
      this._userInteracted = false;
      this._isAnimating = false;
      
      this.init();
    }

    init() {
      // Only setup mobile functionality on mobile
      if (window.innerWidth < 768) {
        if (this.totalItems > 4) {
          this.totalSlides = Math.ceil(this.totalItems / 1.5);
          this.setupDots();
          this.setupEventListeners();
          this.updateCarousel();
        } else {
          // Hide navigation if 4 or fewer products
          if (this.prevBtn) this.prevBtn.style.display = 'none';
          if (this.nextBtn) this.nextBtn.style.display = 'none';
          if (this.dotsContainer) this.dotsContainer.style.display = 'none';
        }
      } else {
        // Desktop: Hide navigation
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        if (this.dotsContainer) this.dotsContainer.style.display = 'none';
      }
      
      this.setupAddToCart();
      this.handleResize();
    }

    setupAddToCart() {
      const addButtons = this.wrapper.querySelectorAll('.cpg-btn-add');
      addButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.classList.contains('cpg-disabled')) return;
          
          const id = this.dataset.id;
          if (!id) return;
          
          const originalText = this.textContent;
          this.textContent = 'Adding...';
          this.style.opacity = '0.7';
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: parseInt(id), quantity: 1 }]
            })
          })
          .then(response => response.json())
          .then(data => {
            this.textContent = 'Added! ✅';
            this.style.opacity = '1';
            setTimeout(() => {
              this.textContent = originalText;
            }, 2000);
            
            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                const cartCount = document.querySelector('.cart-count, .js-cart-count');
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                }
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              });
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            this.textContent = 'Error!';
            this.style.opacity = '1';
            setTimeout(() => {
              this.textContent = originalText;
            }, 2000);
          });
        });
      });
    }

    setupDots() {
      if (!this.dotsContainer) return;
      
      this.dotsContainer.style.display = 'flex';
      this.dotsContainer.innerHTML = '';
      
      const dotCount = Math.max(1, this.totalSlides);
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.classList.add('cpg-dot');
        dot.dataset.index = i;
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.setAttribute('type', 'button');
        if (i === 0) dot.classList.add('cpg-active');
        dot.addEventListener('click', () => {
          this._userInteracted = true;
          this.goToSlide(i);
        });
        this.dotsContainer.appendChild(dot);
      }
      this.updateDots();
    }

    updateDots() {
      if (!this.dotsContainer) return;
      const dots = this.dotsContainer.querySelectorAll('.cpg-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('cpg-active', index === this.currentIndex);
      });
    }

    setupEventListeners() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this._userInteracted = true;
          this.prevSlide();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this._userInteracted = true;
          this.nextSlide();
        });
      }
      
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.handleResize();
        }, 250);
      });

      let touchStartX = 0;
      let touchEndX = 0;

      if (this.grid) {
        this.grid.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.grid.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].screenX;
          this._userInteracted = true;
          this.handleSwipe(touchStartX, touchEndX);
        }, { passive: true });
      }
    }

    handleResize() {
      const isMobile = window.innerWidth < 768;
      
      if (isMobile) {
        // Mobile mode
        if (this.totalItems > 4) {
          this.totalSlides = Math.ceil(this.totalItems / 1.5);
          this.setupDots();
          this.updateCarousel();
          if (this.prevBtn) this.prevBtn.style.display = 'flex';
          if (this.nextBtn) this.nextBtn.style.display = 'flex';
        } else {
          if (this.prevBtn) this.prevBtn.style.display = 'none';
          if (this.nextBtn) this.nextBtn.style.display = 'none';
          if (this.dotsContainer) this.dotsContainer.style.display = 'none';
        }
      } else {
        // Desktop mode - hide all navigation
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        if (this.dotsContainer) this.dotsContainer.style.display = 'none';
        
        // Reset all items to visible
        this.items.forEach(item => {
          item.style.display = 'flex';
          item.style.opacity = '1';
          item.style.position = 'relative';
          item.style.visibility = 'visible';
          item.style.pointerEvents = 'all';
        });
      }
    }

    handleSwipe(startX, endX) {
      if (window.innerWidth >= 768) return;
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    }

    goToSlide(index) {
      if (this._isAnimating) return;
      this.currentIndex = Math.max(0, Math.min(index, this.totalSlides - 1));
      this.updateCarousel();
      this.updateDots();
    }

    prevSlide() {
      if (this._isAnimating || window.innerWidth >= 768) return;
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.totalSlides - 1;
      }
      this.updateCarousel();
      this.updateDots();
    }

    nextSlide() {
      if (this._isAnimating || window.innerWidth >= 768) return;
      if (this.currentIndex < this.totalSlides - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
      this.updateCarousel();
      this.updateDots();
    }

    updateCarousel() {
      if (window.innerWidth >= 768) return;

      const targetCard = this.items[this.currentIndex];
      if (targetCard && this._userInteracted) {
        this._isAnimating = true;
        targetCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
        setTimeout(() => {
          this._isAnimating = false;
        }, 400);
      }
      
      if (this.prevBtn) {
        this.prevBtn.style.opacity = this.totalSlides <= 1 ? '0.3' : '1';
        this.prevBtn.style.pointerEvents = this.totalSlides <= 1 ? 'none' : 'all';
      }
      if (this.nextBtn) {
        this.nextBtn.style.opacity = this.totalSlides <= 1 ? '0.3' : '1';
        this.nextBtn.style.pointerEvents = this.totalSlides <= 1 ? 'none' : 'all';
      }
    }
  }

  function initSections() {
    const sections = document.querySelectorAll('[data-section-type="custom-product-grid"]');
    sections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      if (sectionId && !section._cpg_initialized) {
        section._cpg_initialized = true;
        new CustomProductGrid(sectionId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }
  
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSections);
    document.addEventListener('shopify:section:unload', function(e) {
      const section = e.target;
      if (section._cpg_initialized) {
        delete section._cpg_initialized;
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
